import React from "react";
import tw from "twin.macro";
import styled from "styled-components";
import {Container as ContainerBase } from "components/misc/Layouts.js"
import logo from "../../images/logo.png";
import { ReactComponent as FacebookIcon } from "../../images/facebook-icon.svg";
import { ReactComponent as TwitterIcon } from "../../images/twitter-icon.svg";
// import { ReactComponent as YoutubeIcon } from "../../images/youtube-icon.svg";
import Linkedin  from '../../images/newImg/linkedin.png'
import Insta  from '../../images/newImg/insta.png'
// import {Link} from 'react-router-dom'
// import './assets/main.css'
// import { css } from "styled-components/macro";


const Container = tw(ContainerBase)`bg-gray-900 text-gray-100  -mb-8`
const Content = tw.div`max-w-screen-xl mx-auto py-20 lg:py-24`;

const Row = tw.div`flex items-center justify-center flex-col px-8`

const LogoContainer = tw.div`flex items-center justify-center md:justify-start`;
const LogoImg = tw.img`w-40`;
// const LogoText = tw.h5`ml-2 text-2xl font-black tracking-wider`;

const LinksContainer = tw.div`mt-8 font-medium flex flex-wrap justify-center items-center flex-col sm:flex-row`
const NavLink = tw.a`border-b-2 border-transparent hocus:text-gray-300 hocus:border-gray-300 pb-1 transition duration-300 mt-2 mx-4`;

const SocialLinksContainer = tw.div`mt-10`;
const SocialLink = styled.a`
  ${tw`cursor-pointer inline-block text-gray-100 hover:text-gray-500 transition duration-300 mx-4`}
  svg {
    ${tw`w-5 h-5`}
  }
`;

const CopyrightText = tw.p`text-center mt-10 font-medium tracking-wide text-sm text-gray-600`
export default () => {
  return (
    <Container>
      <Content>
        
        <Row>
          <LogoContainer>
            <LogoImg src={logo} />
            {/* <LogoText>SigSAIL</LogoText> */}
          </LogoContainer>
          <LinksContainer>
          <NavLink href="/">
        Home
      </NavLink>
      <NavLink href="/projects" >
        Projects
      </NavLink>
      {/* <NavLink href="/sigsail-tms">
        SigSAIL TMS
      </NavLink> */}
      <NavLink href="/iiitd-incubated">
      IIITD-IC Incubated
      </NavLink>
      <NavLink href="/clients">
        Clients
      </NavLink>
      <NavLink href="/collaborations">
        Collaborations
      </NavLink>
      <NavLink href="/contact-us">
        Contact us
      </NavLink>
      <NavLink href="/news">
        News
      </NavLink>
      <NavLink href="/careers">
        Careers
      </NavLink>
           
          </LinksContainer>
          <SocialLinksContainer>
            <SocialLink href="https://www.facebook.com/sigsailAI" target="_blank">
              <FacebookIcon />
            </SocialLink>
            <SocialLink href="https://twitter.com/sigsailAI" target="_blank">
              <TwitterIcon />
            </SocialLink>
            <SocialLink href="https://www.linkedin.com/company/sigsailAI" target="_blank">
              <img src={Linkedin} style={{width: "1rem"}} alt="linkedin" />
            </SocialLink>
            <SocialLink href="https://www.instagram.com/sigsailAI" target="_blank">
              <img src={Insta} style={{width: "1rem"}} alt="insta" />
            </SocialLink>
          </SocialLinksContainer>
          <CopyrightText>
            Music by <a href="https://www.bensound.com">bensound.com</a>
          </CopyrightText>
        </Row>
      </Content>
    </Container>
  );
};
